export const FEATURE_SUFFIX_DALI_102 = "daliaddressing102-";
export const FEATURE_SUFFIX_DALI_102_207 = "daliconfiguration102and207-";
export const FEATURE_SUFFIX_AUX = "aux-";
export const FEATURE_SUFFIX_LSI = "lsi-";
export const FEATURE_SUFFIX_AOC_MULTI_CHANNEL = "aocmultichannel-";
export const FEATURE_SUFFIX_OTP = "otp-";
export const FEATURE_SUFFIX_DSC = "dsc-";
export const FEATURE_SUFFIX_LOW_MAINS_LOCK = "lowmainslock-";
export const FEATURE_SUFFIX_DIPSWITCH = "dipswitch-";
export const FEATURE_SUFFIX_DIMMING_INTERFACE = "dimminginterface-";

export const SIMPLE_SET_BOX_CONFIGURATION_VALUE = "SimpleSetBoxConfiguration";
export const PROD_HOSTNAME = "www.multione.signify.com";
export const LUMINFO_FORMAT_PREFIX = "luminfoformat";

export const MODE_STANDARD = "Standard";
export const MODE_ADVANCED = "Advanced";
export const QUICK_CONFIG_MODE = "quickConfig";
export const STANDARD_CONFIG_MODE = "standard";

export const STANDARD_CONFIGURATION_TEXT = "Standard configuration";
export const GUIDED_CONFIGURATION_TEXT = "Guided configuration";
export const DATE_FORMAT_DD_MM_YYYY = "dd-MM-yyyy";

export const FEATURE_NAME_CLO_LITE = "CLOLite";
export const FEATURE_NAME_DALI_PSU = "DALIPSU";
export const FEATURE_NAME_DYNADIMMER = "Dynadimmer";
export const FEATURE_NAME_LUMINFO_FORMAT = "LumInfoFormat";
export const FEATURE_NAME_DALI_ADDRESSING_102 = "DaliAddressing102";
export const FEATURE_NAME_DALI_CONFIGURATION_102_207 = "DaliConfiguration102and207";
export const FEATURE_NAME_TOUCH_DIM = "TouchDim";
export const FEATURE_NAME_DIIA_253_MAINTENANCE = "Diia253Maintenance";

export const FEATURE_LABEL_STARTUP_TIME = "Startup time";
export const FEATURE_LABEL_ZTV = "0-10v / 1-10v";
export const FEATURE_LABEL_CLO_LITE = "CloLite";
export const FEATURE_LABEL_TOUCH_AND_DIM = "Touch and Dim";
export const FEATURE_LABEL_DYNA_DIMMER = "Dyna Dimmer";
export const FEATURE_LABEL_LINE_SWITCH = "Line Switch";
export const FEATURE_LABEL_MIN_DIM_LEVEL = "Min Dim Level";
export const FEATURE_LABEL_AMP_DIM = "Amp Dim";
export const FEATURE_LABEL_AUX_OUTPUT_VOLTAGE = "AUX Output Voltage";
export const FEATURE_LABEL_AOC_MULTI_CHANNEL = "AOC M-Ch";
export const FEATURE_LABEL_OTP = "OTP";
export const FEATURE_LABEL_DSC = "DSC";
export const FEATURE_LABEL_LOW_MAINS_LOCK = "Low Mains Lock";
export const FEATURE_LABEL_DIPSWITCH = "Dipswitch";

export const FEATURE_CONFIGURATION_METADATA_KEYS: ReadonlyArray<string> = [
  "deviceName",
  "device12nc",
  "softwareVerSchema",
  "picture",
  "feature12Nc",
];

export const FEATURE_CONFIGURATION_VERSION_KEYS: ReadonlyArray<string> = [
  "luminSoftVer0",
  "luminSoftVer3",
  "luminSoftVer4",
  "luminSoftVer5",
  "dtlSoftVer",
  "flextuneSoftVer",
  "multiconfigSoftVer",
  "mindimlevelSoftVer",
  "dalipsuSoftVer",
  "ztvSoftVer",
  "ztvoutputSoftVer",
  "lipSoftVer",
  "rsoSoftVer",
  "mtpSoftVer",
  "dimminginterfaceSoftVer",
  "ampdimSoftVer",
  "aocSoftVer",
  "touchdimSoftVer",
  "diia253maintenanceSoftVer",
  "corridorSoftVer",
  "astSoftVer",
  "cloliteSoftVer",
  "cloSoftVer",
  "dynadimmerSoftVer",
  "dcemergencySoftVer",
  "lineswitchSoftVer",
  "owpSoftVer",
  "codedmainsSoftVer",
  "dali102AddressingSoftVer",
  "dali102and207ConfigSoftVer",
  "auxSoftVer",
  "lsiSoftVer",
  "aocmultichannelSoftVer",
  "otpSoftVer",
  "dscSoftVer",
  "lowmainslockSoftVer",
  "dipswitchSoftVer",
];

export const FEATURE_CONFIGURATION_PROPERTY_KEYS: ReadonlyArray<string> = [
  ...FEATURE_CONFIGURATION_METADATA_KEYS,
  ...FEATURE_CONFIGURATION_VERSION_KEYS,
];

export const FEATURE_SELECTION_CANONICAL_MAP: Readonly<Record<string, string>> = {
  "multiconfig": "multiconfigmode-",
  "multiconfigmode": "multiconfigmode-",
  "multiconfigmode-": "multiconfigmode-",
  "alo": "alo-",
  "alo-": "alo-",
  "clo": "clo-",
  "clo-": "clo-",
  "aoc": "aoc-",
  "aoc-": "aoc-",
  "touchdim": "touchdim-",
  "touchdim-": "touchdim-",
  "touch dim": "touchdim-",
  "touch and dim": "touchdim-",
  "diia253maintenance": "diia253maintenance-",
  "diia253maintenance-": "diia253maintenance-",
  "startup time": "ast-",
  "ast": "ast-",
  "ast-": "ast-",
  "dimminginterface": FEATURE_SUFFIX_DIMMING_INTERFACE,
  "dimming interface": FEATURE_SUFFIX_DIMMING_INTERFACE,
  "dimminginterface-": FEATURE_SUFFIX_DIMMING_INTERFACE,
  "mtp": "mtp-",
  "mtp-": "mtp-",
  "luminaire info": "LumInfo",
  "luminfo": "LumInfo",
  "lumin": "LumInfo",
  "sr psu": "srpsu-",
  "srpsu": "srpsu-",
  "srpsu-": "srpsu-",
  "psu": "srpsu-",
  "dali psu": "srpsu-",
  "dalipsu": "srpsu-",
  "dalipsu-": "srpsu-",
  "0-10v / 1-10v": "ztv-",
  "ztv": "ztv-",
  "ztv-": "ztv-",
  "ztvoutput": "ztvoutput-",
  "ztv output": "ztvoutput-",
  "ztvoutput-": "ztvoutput-",
  "lip": "lip-",
  "lip-": "lip-",
  "rso": "rso-",
  "rso-": "rso-",
  "clolite": "clolite-",
  "clolite-": "clolite-",
  "corridor": "corridor-",
  "corridor-": "corridor-",
  "dc emergency": "dcemergency-",
  "dcemergency": "dcemergency-",
  "dcemergency-": "dcemergency-",
  "dyna dimmer": "dynadimmer-",
  "dynadimmer": "dynadimmer-",
  "dynadimmer-": "dynadimmer-",
  "line switch": "lineswitch-",
  "lineswitch": "lineswitch-",
  "lineswitch-": "lineswitch-",
  "owp": "owp-",
  "owp-": "owp-",
  "codedmains": "codedmains-",
  "coded mains": "codedmains-",
  "codedmains-": "codedmains-",
  "dali 102 addressing": FEATURE_SUFFIX_DALI_102,
  "dali102addressing": FEATURE_SUFFIX_DALI_102,
  "daliaddressing102": FEATURE_SUFFIX_DALI_102,
  "daliaddressing102-": FEATURE_SUFFIX_DALI_102,
  "dali configuration 102 and 207": FEATURE_SUFFIX_DALI_102_207,
  "dali 102 and 207 configuration": FEATURE_SUFFIX_DALI_102_207,
  "dali102and207configuration": FEATURE_SUFFIX_DALI_102_207,
  "daliconfiguration102and207": FEATURE_SUFFIX_DALI_102_207,
  "daliconfiguration102and207-": FEATURE_SUFFIX_DALI_102_207,
  "aux output voltage": FEATURE_SUFFIX_AUX,
  "aux": FEATURE_SUFFIX_AUX,
  "aux-": FEATURE_SUFFIX_AUX,
  "lsi": FEATURE_SUFFIX_LSI,
  "lsi-": FEATURE_SUFFIX_LSI,
  "dsc": FEATURE_SUFFIX_DSC,
  "dsc-": FEATURE_SUFFIX_DSC,
  "lowmainslock": FEATURE_SUFFIX_LOW_MAINS_LOCK,
  "lowmainslock-": FEATURE_SUFFIX_LOW_MAINS_LOCK,
  "dipswitch": FEATURE_SUFFIX_DIPSWITCH,
  "dipswitch-": FEATURE_SUFFIX_DIPSWITCH,
  "aoc m-ch": FEATURE_SUFFIX_AOC_MULTI_CHANNEL,
  "aocmultichannel": FEATURE_SUFFIX_AOC_MULTI_CHANNEL,
  "aocmultichannel-": FEATURE_SUFFIX_AOC_MULTI_CHANNEL,
  "otp": FEATURE_SUFFIX_OTP,
  "otp-": FEATURE_SUFFIX_OTP,
  "amp dim": "ampdim-",
  "ampdim": "ampdim-",
  "ampdim-": "ampdim-",
  "dtl": "dtl-",
  "dtl-": "dtl-",
  "flex tune": "flextune-",
  "flextune": "flextune-",
  "flextune-": "flextune-",
  "multi config mode": "multiconfigmode-",
  "min dim level": "mindimlevel-",
  "min dimlevel": "mindimlevel-",
  "mindimlevel": "mindimlevel-",
  "mindimlevel-": "mindimlevel-",
};

export function normalizeFeatureSelectionAlias(feature: string | null | undefined): string {
  const trimmedFeature = (feature || "").trim();
  const normalizedFeature = trimmedFeature.toLowerCase();

  if (normalizedFeature.startsWith(LUMINFO_FORMAT_PREFIX)) {
    return trimmedFeature;
  }

  return FEATURE_SELECTION_CANONICAL_MAP[normalizedFeature] || trimmedFeature;
}

export function matchesFeatureSelectionAlias(
  feature: string | null | undefined,
  ...aliases: string[]
): boolean {
  if (!feature) {
    return false;
  }

  const normalizedFeature = normalizeFeatureSelectionAlias(feature);
  return aliases.some((alias) => normalizeFeatureSelectionAlias(alias) === normalizedFeature);
}

export const SUPPORTED_WEB_FEATURES: ReadonlyArray<string> = [
  "ztvoutput-",
  "0-10v / 1-10v",
  "ztv-",
  "Startup time",
  "ast-",
  "Aoc",
  "aoc-",
  "Alo",
  "alo-",
  "Srpsu",
  "Psu",
  "dalipsu-",
  "srpsu-",
  "luminfoformat5-",
  "luminfoformat4-",
  "luminfoformat3-",
  "luminfoformat0-",
  "clo-",
  FEATURE_NAME_CLO_LITE,
  "clolite-",
  "owp-",
  "DTL",
  "dtl-",
  "flextune-",
  "lineswitch-",
  "codedmains-",
  "ampdim-",
  "corridor-",
  "mtp-",
  "dcemergency-",
  "diia253maintenance-",
  "lip-",
  "rso-",
  "touchdim-",
  "dynadimmer-",
  "Min Dim Level",
  "Min dim level",
  "mindimlevel-",
  FEATURE_SUFFIX_DIMMING_INTERFACE,
  "multiconfigmode-",
  FEATURE_SUFFIX_DALI_102,
  FEATURE_SUFFIX_DALI_102_207,
  FEATURE_SUFFIX_AUX,
  FEATURE_SUFFIX_LSI,
  FEATURE_SUFFIX_AOC_MULTI_CHANNEL,
  FEATURE_SUFFIX_OTP,
  FEATURE_SUFFIX_DSC,
  FEATURE_SUFFIX_LOW_MAINS_LOCK,
  FEATURE_SUFFIX_DIPSWITCH
];
